import PropTypes from 'prop-types'

import { IncidentImpact } from '../../models/public-incidents/incident-impact'
import { IncidentStatus } from '../../models/public-incidents/incident-status'
import { iso8601PropType } from '../common/iso-8601-prop-type'
import { publicIncidentComponentPropType } from './public-incident-component-prop-type'

/**
 * @typedef {Object} PublicIncident
 * @property {string} id - Incident Identifier
 * @property {string} title - Title of the incident
 * @property {PublicIncidentComponent[]} [components] - Affected incident components
 * @property {ISO8601} [created_at] - The timestamp when the incident was created at
 * @property {string} [description] - Detailed translated description of the incident
 * @property {string} [impact] - The impact of the incident
 * @property {boolean} [maintenance] - Flag that indicated, if the incident is a maintenance
 * @property {ISO8601} [scheduledFor] - Only Maintenance. The timestamp the incident is scheduled for. Format like 2013-05-07T03:00:00.007Z
 * @property {ISO8601} [scheduledUntil] - Only Maintenance. The timestamp the incident is scheduled until. Format like 2013-05-07T03:00:00.007Z
 * @property {string} [status] - The incident status. For realtime incidents, valid values are investigating, identified, monitoring, and resolved. For scheduled incidents, valid values are scheduled, in_progress, verifying, and completed.
 * @property {string} [subtitle] - Subtitle of the incident
 * @property {ISO8601} [updated_at] - The timestamp when the incident was updated at
 */
export const publicIncidentPropType = PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    components: PropTypes.arrayOf(publicIncidentComponentPropType),
    created_at: iso8601PropType,
    description: PropTypes.string,
    impact: PropTypes.oneOf(Object.values(IncidentImpact)),
    maintenance: PropTypes.bool,
    scheduledFor: iso8601PropType,
    scheduledUntil: iso8601PropType,
    status: PropTypes.oneOf(Object.values(IncidentStatus)),
    subtitle: PropTypes.string,
    updated_at: iso8601PropType
})
